import { toastConfig } from 'lib/reactToastify/config';
import { Id, toast } from 'react-toastify';

import { logError } from 'lib/sentry/logError';

import { IChallengeTimelineItem } from 'features/challenge/ChallengeTimelineItem';
import { CHALLENGE_LOCATIONS } from 'features/challenge/config';
import { useEditChallengesMutation } from 'features/challenge/hooks/mutation/useEditChallenges';
import { useExploreChallengesDialog } from 'features/challenge/hooks/useExploreChallengesDialog';
import {
  usePlanningAnalyticsEvents,
  usePlanningBacklogQueryActions,
} from 'features/planning';

export const useBacklogAddLibraryChallenge = () => {
  const { invalidateBacklogQuery } = usePlanningBacklogQueryActions();

  const { mutateAsync: editChallenges } =
    useEditChallengesMutation<IChallengeTimelineItem>({
      options: {
        onSuccess: () => {
          invalidateBacklogQuery();
        },
      },
    });
  const { sendPlanningChallengeAddedEvent } = usePlanningAnalyticsEvents();

  const onSubmit = async (
    newChallenges: IChallengeTimelineItem | IChallengeTimelineItem[],
    toastId: Id | undefined
  ) => {
    let submitToastId: Id | undefined;
    try {
      if (!toastId) {
        submitToastId = toast.loading(
          'Adding challenges to sprint...',
          toastConfig
        );
      }
      const challenges = Array.isArray(newChallenges)
        ? newChallenges
        : [newChallenges];

      await editChallenges({
        challenges,
        parameters: { addToBacklog: true },
      });

      sendPlanningChallengeAddedEvent(CHALLENGE_LOCATIONS.BACKLOG);

      !toastId && toast.dismiss(submitToastId);
    } catch (error) {
      logError(error);
    }
  };

  const openExploreChallengesModal = useExploreChallengesDialog(
    // @ts-ignore
    {
      onSubmit,
    }
  );

  return openExploreChallengesModal;
};
